// import sidebar from '@/config/sidebars/geobooster'
// import createVueApp from '@/common/create_app'

Styxie.Initializers.MobileCompanyCamProjects = {
  // Phase 2: Projects Index
  // index: async(props) => { ... }

  // Phase 2: Project Show
  // show: async(props) => { ... }
}
